import { createSlice } from "@reduxjs/toolkit";
import {
    fetchManufacturers,
    fetchCuttingLogic,
    saveCuttingLogic,
    deleteCuttingLogic
} from "./cuttingLogicThunk";

const initialState = {
    id: null,
    manufacturers: [],
    logicList: [],
    selectedManufacturer: null,
    parserManufacturer: null,
    gtin_from: null,
    gtin_to: null,
    batch_from: null,
    batch_to: null,
    expiry_from: null,
    expiry_to: null,
    serial_from: null,
    serial_to: null,
    qrCode: '',
    parsedGtin: '',
    parsedBatch: '',
    parsedExpiry: '',
    parsedSerial: '',
    saving: false,
    deleting: false,
    loading: false
};

const cuttingLogicSlice = createSlice({
    name: "cuttingLogic",
    initialState,
    reducers: {
        setFormField(state, action) {
            const { field, value } = action.payload;
            state[field] = value;
        },

        setLogic(state, action) {
            Object.assign(state, action.payload);
        },

        resetForm(state) {
            state.id = null;
            state.selectedManufacturer = null;
            state.gtin_from = null;
            state.gtin_to = null;
            state.batch_from = null;
            state.batch_to = null;
            state.expiry_from = null;
            state.expiry_to = null;
            state.serial_from = null;
            state.serial_to = null;
            state.qrCode = '';
            state.parsedGtin = '';
            state.parsedBatch = '';
            state.parsedExpiry = '';
            state.parsedSerial = '';
        },

        setQrCode(state, action) {
            state.qrCode = action.payload;
        },

        setParsedValues(state, action) {
            state.parsedGtin = action.payload.gtin;
            state.parsedBatch = action.payload.batch;
            state.parsedExpiry = action.payload.expiry;
            state.parsedSerial = action.payload.serial;
        },

        clearParser(state) {
            state.parserManufacturer = null;
            state.qrCode = '';
            state.parsedGtin = '';
            state.parsedBatch = '';
            state.parsedExpiry = '';
            state.parsedSerial = '';
        }
    },

    extraReducers: (builder) => {
        builder
            // ========== FETCH MANUFACTURERS ==========
            .addCase(fetchManufacturers.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchManufacturers.fulfilled, (state, action) => {
                state.loading = false;
                state.manufacturers = action.payload;
            })
            .addCase(fetchManufacturers.rejected, (state) => {
                state.loading = false;
            })

            // ========== FETCH CUTTING LOGIC ==========
            .addCase(fetchCuttingLogic.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchCuttingLogic.fulfilled, (state, action) => {
                state.loading = false;
                state.logicList = action.payload;
            })
            .addCase(fetchCuttingLogic.rejected, (state) => {
                state.loading = false;
            })

            // ========== SAVE CUTTING LOGIC ==========
            .addCase(saveCuttingLogic.pending, (state) => {
                state.saving = true;
                state.loading = true;
            })
            .addCase(saveCuttingLogic.fulfilled, (state) => {
                state.saving = false;
                state.loading = false;
            })
            .addCase(saveCuttingLogic.rejected, (state) => {
                state.saving = false;
                state.loading = false;
            })

            // ========== DELETE CUTTING LOGIC ==========
            .addCase(deleteCuttingLogic.pending, (state) => {
                state.deleting = true;
                state.loading = true;
            })
            .addCase(deleteCuttingLogic.fulfilled, (state) => {
                state.deleting = false;
                state.loading = false;
            })
            .addCase(deleteCuttingLogic.rejected, (state) => {
                state.deleting = false;
                state.loading = false;
            });
    }
});

export const {
    setFormField,
    setLogic,
    resetForm,
    setQrCode,
    setParsedValues,
    clearParser
} = cuttingLogicSlice.actions;

export default cuttingLogicSlice.reducer;